module.exports = __webpack_public_path__ + "static/media/cloud-upload.ef16b1f6.svg";